"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Breakpoints;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useBreakpoints = _interopRequireDefault(require("./use-breakpoints"));

function Breakpoints(_ref) {
  let {
    children,
    breakpoints
  } = _ref;
  const {
    breakpoint
  } = (0, _useBreakpoints.default)(...breakpoints);
  return children({
    breakpoint
  });
}

Breakpoints.propTypes = {
  breapoints: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf('string')]),

  /** remaining elements to render */
  children: _propTypes.default.any
};